<template>
    <div class="app-select">
        <label class="app-select__label">{{ getTranslatedText('Select the event') }}</label>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language/language-mixins'

export default {
    mixins: [languageMixins],
}
</script>

<style lang="scss">
@import '~ThemePath/scss/games/_select.scss';
</style>
